import { Flex } from '@radix-ui/themes';
import { CommonCallout } from 'components/common/callouts';
import { ErrorBoundary } from 'components/common/error-boundary';
import { DataControls } from 'components/sections/admin-portal/server-controls/data-controls';
import { GameStatusControls } from 'components/sections/admin-portal/server-controls/game-status/controls';
import { GameStatusSummary } from 'components/sections/admin-portal/server-controls/game-status/summary';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useAuthStore } from 'stores/use-auth-store';

export const ServerControlsTab = () => {
  const userRoleFeatureFlags = useAuthStore((s) => s.userRoleFeatureFlags);

  if (!userRoleFeatureFlags.sections.adminServerControls) {
    return (
      <CommonCallout
        color={RADIX.COLOR.SUPER_ADMIN}
        text="You do not have access to this feature."
      />
    );
  }

  return (
    <ErrorBoundary identifier="GameStatusTab">
      <Flex direction="column" gap={RADIX.FLEX.GAP.SECTION}>
        <DataControls />
        <GameStatusControls />
        <GameStatusSummary />
      </Flex>
    </ErrorBoundary>
  );
};
